const buddyEl = document.getElementById('buddy');
const buddyInner = buddyEl.querySelector('div');
const buddyOffsetX = buddyEl.clientWidth / 2;
const buddyOffsetY = buddyEl.clientHeight / 2;
const distanceOffset = 30;

const retriggerClassAnimation = (el, animClass) => {
  el.classList.remove(animClass);
  requestAnimationFrame((time) => {
    requestAnimationFrame((time) => {
      el.classList.add(animClass);
    });
  });
}

const init = () => {
  document.addEventListener('mousemove', e => {
    const { pageX: x, pageY: y } = e;
    buddyEl.style.transform = `translate(${ x - buddyOffsetX + distanceOffset }px, ${ y - buddyOffsetY + distanceOffset }px)`;
  });

  window.addEventListener('click', e => {
    console.log('click');
    retriggerClassAnimation(buddyInner, '_jiggle');
  });
}

window.addEventListener('load', e => {
  init();
});